import React from 'react';
import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {calendarDate} from 'shared/tools';
import {QuickTip, Table} from 'components';
import _ from 'lodash';
import {FormattedMessage} from 'react-intl';

const COLUMNS = [
  {
    header: 'nmbr.updates.directory.Effective Date',
    width: 6,
    render: model => calendarDate(model.effectiveFrom)
  },
  {
    header: 'nmbr.updates.directory.Province of Employment',
    width: 6,
    attribute: 'formattedValue'
  },
];

const TaxPropertiesTable = observer(({nmbrUpdate}) => {
  if (!(nmbrUpdate.hasFieldUpdate('tax_properties') || nmbrUpdate.hasFieldUpdate('failed_tax_properties'))) return null;

  return (
    <div className='space-y'>
      <div className='h3 medium'><FormattedMessage id='nmbr.updates.directory.Province of Employment'/></div>
      {nmbrUpdate.hasFieldUpdate('tax_properties') && <Table
        columns={COLUMNS}
        models={_.filter(nmbrUpdate.fieldUpdates, {updateType: 'tax_properties'})}
        showLinks={false}
      />}
      {nmbrUpdate.hasFieldUpdate('failed_tax_properties') && <QuickTip
        trait='error'
        header={t('nmbr.updates.directory.Some provinces of employment could not be processed')}
        paragraphs={[
          <ul className='ml2'>
            {nmbrUpdate.fieldUpdatesForType('failed_tax_properties').map(field_update => <li>
              {t('nmbr.updates.directory.EMPLOYMENT_RECORD_ERROR', {
                effectiveDate: calendarDate(field_update.effectiveDate),
                recordType: t(`nmbr.errors.record_types.${field_update.recordType}`),
                errors: field_update.translateErrors ? field_update.errors.map(error => t(`nmbr.errors.messages.${error}`)).join(' ') : field_update.errors.join(' ')
              })}
            </li>)}
          </ul>
        ]}/>}
    </div>
  );
});

export default TaxPropertiesTable;
